// extracted by mini-css-extract-plugin
export default {"visibleDialog":"pushNotifications-module-b50d234cbb215d568606","hiddenDialog":"pushNotifications-module-ec8ad3d3d1fe279848a3"};